require("!!C:\\Users\\Sohaib Ahmed\\Documents\\Visual Studio 2017\\Projects\\Servis-web\\servis_angular\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\Sohaib Ahmed\\Documents\\Visual Studio 2017\\Projects\\Servis-web\\servis_angular\\node_modules\\raw-loader\\index.js!C:\\Users\\Sohaib Ahmed\\Documents\\Visual Studio 2017\\Projects\\Servis-web\\servis_angular\\node_modules\\chart.js\\dist\\Chart.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chart.js/dist/Chart.min.js
// module id = 232
// module chunks = 13